/**
 * 7-day grid for daily_checkin. Past days = green check, today = yellow with
 * amount + white border, future = gray with preview amount.
 */
import { useTranslation } from 'react-i18next';
import { Check } from 'lucide-react';
import { Money } from '@/components/money/Money.js';

interface Props {
  schedule: bigint[];        // length 7, minor units per day
  currentDay: number;        // 1..7
  daysClaimed: number[];     // subset of 1..7
  currency: string;
  highlight?: boolean;
}

export function CheckinCalendar({
  schedule,
  currentDay,
  daysClaimed,
  currency,
  highlight = true,
}: Props) {
  const { t } = useTranslation('promo');
  return (
    <div className="grid grid-cols-7 gap-[3px]">
      {schedule.map((amount, i) => {
        const day = i + 1;
        const done = daysClaimed.includes(day);
        const today = day === currentDay && !done;

        const bg = done ? 'bg-[var(--success)]' : today ? 'bg-[#fbbf24]' : 'bg-[var(--bg-elevated)]';
        const text = done ? 'text-white' : today ? 'text-black' : 'text-[var(--text-muted)]';
        const border = today && highlight ? 'ring-2 ring-white' : '';

        return (
          <div
            key={day}
            className={`aspect-square rounded-md flex flex-col items-center justify-center text-[9px] font-bold ${bg} ${text} ${border}`}
          >
            <span>{t('card.daily_checkin.dayLabel', { n: day })}</span>
            {done ? (
              <Check size={10} strokeWidth={3} />
            ) : (
              <span><Money minor={amount} currency={currency} /></span>
            )}
          </div>
        );
      })}
    </div>
  );
}
